<template>
  <div class="container">
    <div class="nps-container">
      <img class="nps-bg-image" :src="npsDetail.img_app_h5_bg" alt="" />
      <template v-if="questionPage === 3">
        <div class="question-success-container">
          <img
            class="question-success-img"
            :src="npsDetail.img_app_h5_ok"
            alt=""
          />
        </div>
      </template>
      <template v-else>
        <div class="question-list-container">
          <template v-for="item in showQuestion">
            <template v-if="item.question_type === 1">
              <!--        nps问题-->
              <div class="question-container" :key="item.id">
                <div>
                  <span v-if="item.required === 1" class="question-must-fill"
                    >*
                  </span>
                  <span class="question-title">{{ item.question }}</span>
                </div>
                <div class="question-content">
                  <van-radio-group
                    v-model="item.radio_value"
                    direction="horizontal"
                    class="question-nps-group"
                    @change="radioChange"
                  >
                    <template v-for="(option, index) in item.option_list">
                      <van-radio :name="option" :key="option.id">
                        <template #icon="props">
                          <div
                            v-if="props.checked"
                            class="question-nps-checked"
                          >
                            {{ index }}
                          </div>
                          <div v-else class="question-nps-unchecked">
                            {{ index }}
                          </div>
                        </template>
                      </van-radio>
                    </template>
                  </van-radio-group>
                </div>
                <div class="question-img-content">
                  <div class="question-img-item">
                    <img
                      class="question-img"
                      src="@/assets/NpsNew/unsatisfied.png"
                      alt=""
                    />
                    <span class="question-img-text">非常不推荐</span>
                  </div>
                  <div class="question-img-item">
                    <img
                      class="question-img"
                      src="@/assets/NpsNew/satisfied.png"
                      alt=""
                    />
                    <span class="question-img-text">非常推荐</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="item.option_type === 1">
                <!--        单选问题-->
                <div class="question-container" :key="item.id">
                  <div>
                    <span v-if="item.required === 1" class="question-must-fill"
                      >*
                    </span>
                    <span class="question-title">{{ item.question }}</span>
                  </div>
                  <div class="question-content">
                    <van-radio-group
                      class="question-radio-group"
                      v-model="item.radio_value"
                      @change="radioChange"
                    >
                      <template v-for="option in item.option_list">
                        <van-radio
                          :class="
                            option.option.length > 10
                              ? 'question-radio'
                              : 'question-radio-center'
                          "
                          :name="option"
                          :key="option.id"
                        >
                          <div
                            :class="
                              option.option.length > 10
                                ? 'question-radio-container-column'
                                : 'question-radio-container-row'
                            "
                          >
                            <div>{{ option.option }}</div>
                            <van-field
                              :disabled="item.radio_value === option.id"
                              placeholder="50字以内"
                              maxlength="50"
                              v-if="option.input_box === 1"
                              :class="
                                item.radio_value === option.id
                                  ? 'question-radio-input-disabled'
                                  : 'question-radio-input'
                              "
                              v-model="option.input_value"
                            />
                          </div>
                        </van-radio>
                      </template>
                    </van-radio-group>
                  </div>
                </div>
              </template>
              <template v-if="item.option_type === 2">
                <!--        多选问题-->
                <div class="question-container" :key="item.id">
                  <div>
                    <span v-if="item.required === 1" class="question-must-fill"
                      >*
                    </span>
                    <span class="question-title">{{ item.question }}</span>
                  </div>
                  <div class="question-content">
                    <van-checkbox-group
                      class="question-checkbox-group"
                      v-model="item.checkbox_value"
                      @change="
                        (checkedValues) =>
                          onCheckboxChange(checkedValues, item.id)
                      "
                    >
                      <template v-for="option in item.option_list">
                        <van-checkbox
                          checked-color="#00BE8A"
                          shape="square"
                          :class="
                            option.option.length > 10
                              ? 'question-checkbox'
                              : 'question-checkbox-center'
                          "
                          :name="option"
                          :key="option.id"
                        >
                          <div
                            :class="
                              option.option.length > 10
                                ? 'question-checkbox-container-column'
                                : 'question-checkbox-container-row'
                            "
                          >
                            <div style="flex-shrink: 0">
                              {{ option.option }}
                            </div>
                            <van-field
                              @click.stop
                              :disabled="
                                disabledInput(item.checkbox_value, option.id)
                              "
                              v-if="option.input_box === 1"
                              :class="
                                disabledInput(item.checkbox_value, option.id)
                                  ? 'question-radio-input-disabled'
                                  : 'question-radio-input'
                              "
                              placeholder="50字以内"
                              maxlength="50"
                              v-model="option.input_value"
                            />
                          </div>
                        </van-checkbox>
                      </template>
                    </van-checkbox-group>
                  </div>
                </div>
              </template>
              <template v-if="item.option_type === 3">
                <!--        输入框问题-->
                <div class="question-container" :key="item.id">
                  <div>
                    <span v-if="item.required === 1" class="question-must-fill"
                      >*
                    </span>
                    <span class="question-title">{{ item.question }}</span>
                  </div>
                  <div class="question-content">
                    <van-field
                      class="question-input"
                      placeholder="请输入（300字以内）
如您愿意接受回访，请留下您的手机号"
                      maxlength="300"
                      type="textarea"
                      :auto-size="{ minRows: 6 }"
                      v-model="item.input_value"
                    />
                  </div>
                </div>
              </template>
            </template>
          </template>
          <van-button
            type="primary"
            :disabled="!canSubmit()"
            class="bottom-button"
            @click="onSubmit"
            >提交
          </van-button>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup>
import {
  getOpenReleaseNpsDetail,
  saveOpenNpsAnswer,
} from "@/services/NpsPublic";

export default {
  data() {
    return {
      npsDetail: {
        originMainQuestions: [], //未修改第一页主要问题
        mainQuestions: [], //第一页主要问题
        originOptionQuestions: [], //未修改第二页问题
        optionQuestions: [], //第二页问
        img_app_h5_bg: "", //背景图片
        img_app_h5_ok: "",
        nps_id: -1,
      },
      questions: {}, // 问题数组
      questionPage: 1, //1: 第一页 2: 第二页 //成功页
      answers: {},
      uid: 0,
      channel: "",
    };
  },
  methods: {
    // 将所有问题按照id的方式
    organizeQuestionsById(data) {
      // 遍历 question_list，将问题按 id 组织成对象
      const organizedQuestions = data.ret_data.question_list.reduce(
        (acc, question) => {
          // 处理每个问题的 condition_list
          question.condition_list.forEach((condition) => {
            const subQuestionIds = condition.sub_question_id_list;
            // 遍历 option_list，将 sub_question_id_list 放入对应的 option 中
            condition.option_id_list.forEach((optionId) => {
              const option = question.option_list.find(
                (opt) => opt.id === optionId
              );
              option.input_value = "";
              if (option) {
                option.sub_question_ids = subQuestionIds; // 添加 sub_question_ids 到 option 中
              }
            });
          });
          if ("sub_question_list" in question) {
            console.log("sub_question_list", question.sub_question_list);
            question.sub_question_list.forEach((subQuestion) => {
              // 按 id 存储子问题
              acc[subQuestion.id] = subQuestion;
            });
          }

          if (question.option_type === 1) {
            question.radio_value = null;
          }
          if (question.option_type === 2) {
            question.checkbox_value = [];
          }
          if (question.option_type === 3) {
            question.input_value = "";
          }
          // 按 id 存储问题
          acc[question.id] = question;
          return acc;
        },
        {}
      );
      return organizedQuestions;
    },
    // 单选框改变
    radioChange(e) {
      console.log(e);
      this.answers[e.question_id] = [e];
      this.recombinationQuestions();
    },
    // 多选改变
    onCheckboxChange(checkedValues, questionId) {
      if (checkedValues.length === 0) {
        delete this.answers[questionId];
      } else {
        this.answers[questionId] = checkedValues;
      }
      this.recombinationQuestions();
    },
    // 动态根据选择的选项修改问题列表
    recombinationQuestions() {
      const processQuestions = (questions, originQuestions) => {
        let newQuestion = [...originQuestions];
        Object.values(this.answers).forEach((options) => {
          if (options.length > 0) {
            let subIds = [];
            options.forEach((option) => {
              if ("sub_question_ids" in option) {
                option.sub_question_ids.forEach((subQuestionId) => {
                  if (!subIds.includes(subQuestionId)) {
                    subIds.push(subQuestionId);
                    const subQuestion = this.questions[subQuestionId];
                    newQuestion = this.insertAfterId(
                      newQuestion,
                      option.question_id,
                      subQuestion
                    );
                  }
                });
              }
            });
          }
        });
        return newQuestion;
      };

      if (this.questionPage === 1) {
        this.npsDetail.mainQuestions = processQuestions(
          this.questions,
          this.npsDetail.originMainQuestions
        );
      } else {
        this.npsDetail.optionQuestions = processQuestions(
          this.questions,
          this.npsDetail.originOptionQuestions
        );
      }
      this.recombinationAnswer();
    },
    // 动态修改answer
    recombinationAnswer() {
      const ids = this.npsDetail.mainQuestions
        .map((item) => item.id)
        .concat(this.npsDetail.optionQuestions.map((item) => item.id));

      const filteredData = Object.keys(this.answers)
        .filter((key) => ids.includes(parseInt(key))) // 过滤出在 ids 数组中的键
        .reduce((result, key) => {
          result[key] = this.answers[key]; // 构造新的过滤后的对象
          return result;
        }, {});
      this.answers = filteredData;
    },
    // 根据ID插入动态数据方法
    insertAfterId(dataArray, id, newData) {
      const index = dataArray.findIndex((item) => item.id === id);
      if (index !== -1) {
        dataArray.splice(index + 1, 0, newData);
      } else {
        console.error(`未找到 id 为 ${id} 的元素`);
      }
      return dataArray;
    },
    canSubmit() {
      const questions =
        this.questionPage === 1
          ? this.npsDetail.mainQuestions
          : this.npsDetail.optionQuestions;

      for (const question of questions) {
        // 如果 required 为 1，表示这是必填项

        if (question.required === 1) {
          switch (question.option_type) {
            case 1: // 单选题
              if (!question.radio_value) {
                return false; // radio_value 为空
              }
              break;
            case 2: // 多选题
              if (
                !question.checkbox_value ||
                question.checkbox_value.length === 0
              ) {
                return false; // checkbox_value 长度小于 1
              }
              break;
            case 3: // 输入题
              if (question.input_value === "") {
                return false; // input_value 为空
              }
              break;

            default:
              break;
          }
        }
      }
      return true; // 所有必填项都满足条件
    },
    onSubmit() {
      if (this.questionPage === 1) {
        // 这里特殊处理 当channel 为 preview的时候，实际为后台管理系统预览，不需要提交数据，紧提供预览功能
        if (this.channel === "preview") {
          this.answers = {};
          if (this.npsDetail.optionQuestions.length === 0) {
            this.questionPage = 3;
          } else {
            this.questionPage = 2;
          }
        } else {
          const param = {
            ua: this.channel,
            nps_id: this.npsDetail.nps_id,
            answer_status: 1, //第一次提交
            answer_list: this.getAnswerListParam(this.npsDetail.mainQuestions),
          };
          saveOpenNpsAnswer(param).then((res) => {
            console.log(res);
            this.answers = {};
            if (this.npsDetail.optionQuestions.length === 0) {
              this.questionPage = 3;
            } else {
              this.questionPage = 2;
            }
          });
          return;
        }
      }

      if (this.questionPage === 2) {
        if (this.channel === "preview") {
          this.questionPage = 3;
        } else {
          const param = {
            ua: this.channel,
            nps_id: this.npsDetail.nps_id,
            answer_status: 2, //第二次提交
            answer_list: this.getAnswerListParam(
              this.npsDetail.optionQuestions
            ),
          };
          saveOpenNpsAnswer(param).then((res) => {
            console.log(res);
            this.questionPage = 3;
          });
        }
      }
    },
    disabledInput(checkbox_value, id) {
      if (
        !checkbox_value ||
        checkbox_value.findIndex((item) => item.id === id) === -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 生成答案数据
    getAnswerListParam(dataArr) {
      const param = [];
      dataArr.forEach((item) => {
        if (item.option_type === 1) {
          if ("radio_value" in item && item.radio_value !== null) {
            param.push({
              question_id: item.id,
              option_type: item.option_type,
              option_list: [
                {
                  id: item.radio_value.id,
                  input_box:
                    "input_value" in item.radio_value
                      ? item.radio_value.input_value
                      : "",
                },
              ],
              input_box: "",
            });
          }
        }
        if (item.option_type === 2) {
          if ("checkbox_value" in item && item.checkbox_value.length > 0) {
            const optionList = item.checkbox_value.map((option) => {
              return {
                id: option.id,
                input_box: "input_value" in option ? option.input_value : "",
              };
            });
            param.push({
              question_id: item.id,
              option_type: item.option_type,
              option_list: optionList,
              input_box: "",
            });
          }
        }
        if (item.option_type === 3) {
          if ("input_value" in item && item.input_value !== "") {
            param.push({
              question_id: item.id,
              option_type: item.option_type,
              option_list: [],
              input_box: item.input_value,
            });
          }
        }
      });
      return param;
    },
  },
  computed: {
    showQuestion() {
      return this.questionPage === 1
        ? this.npsDetail.mainQuestions
        : this.npsDetail.optionQuestions;
    },
  },
  mounted() {
    //生成Uid 规则毫秒时间戳在 后面拼接 4位随机数吧
    const uid = new Date().getTime() + "" + Math.floor(Math.random() * 10000);
    this.uid = uid;

    console.log(uid);
    console.log(this.$route.query);
    if (this.$route.query && "channel" in this.$route.query) {
      this.channel = this.$route.query.channel;
      getOpenReleaseNpsDetail({
        user_id: this.uid,
        nps_id: this.$route.query.nps_id,
      }).then((res) => {
        this.npsDetail.img_app_h5_bg = res.ret_data.img_app_h5_bg;
        this.npsDetail.img_app_h5_ok = res.ret_data.img_app_h5_ok;
        this.npsDetail.nps_id = res.ret_data.id;
        //重新整理问题
        this.questions = this.organizeQuestionsById(res);
        // 获取popup问题id
        const popupQuestionIds = res.ret_data.pc_popup_list.map(
          (popup) => popup.question_id
        );
        // 将问题分类到 mainQuestions 和 optionQuestions
        res.ret_data.question_list.forEach((item) => {
          const question = this.questions[item.id];
          if (popupQuestionIds.includes(parseInt(item.id))) {
            this.npsDetail.mainQuestions.push(question);
          } else {
            this.npsDetail.optionQuestions.push(question);
          }
        });
        this.npsDetail.originMainQuestions = this.npsDetail.mainQuestions;
        this.npsDetail.originOptionQuestions = this.npsDetail.optionQuestions;
      });
    }
  },
};
</script>
<style scoped lang="less">
.container {
  display: flex;
  justify-content: center;
}

.nps-container {
  position: relative;
  min-height: 501px;
  max-height: calc(100vh - 129px);
  width: 100%;
}

.close-button {
  width: 32px;
  height: 32px;
  color: #ffffff;
}

.nps-bg-image {
  position: absolute;
  width: 100%;
  height: auto;
}

.nps-finish-image {
  position: absolute;
  width: 100%;
  height: auto;
  border-radius: 24px;
}

.question-list-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  top: 129px;
  margin: 0 8px 129px 8px;
  background: #ffffff;
  box-shadow: 0 0 24px 0 #75f8e21a;
  border-radius: 8px;
  overflow-x: scroll;
  max-height: calc(100vh - 129px);
  padding: 19px 12px;
}

.question-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-must-fill {
  color: #ff4d4f;
  font-size: 12px;

  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;

  text-align: left;
}

.question-title {
  width: 688px;
  height: 22px;
  font-weight: 600;
  font-size: 12px;
  color: #000000d9;
  line-height: 22px;
}

.bottom-button {
  width: 100%;
  line-height: 48px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin: 40px 0 20px 0;
}

.question-img-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.question-img-item {
  display: flex;
  align-items: center;
}

.question-img {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.question-img-text {
  width: 60px;
  height: 20px;
  font-weight: 400;
  font-size: 11px;
  color: #00000073;
  line-height: 20px;
}

.question-img-margin {
  margin-right: 200px;
}

.question-radio {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-weight: 400;
  font-size: 12px;
  color: #000000d9;
  line-height: 22px;
  margin-right: 0;
}

.question-radio-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #000000d9;
  line-height: 22px;
  margin-right: 0;
}

.question-radio-container-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.question-radio-container-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.question-radio-input {
  height: 32px;
  padding: 8px 12px;
  font-weight: 400;
  font-size: 12px;
  color: #000000d9;
  line-height: 22px;
  flex-grow: 1;
  background: #0000000a;
  border-radius: 4px;
}
.question-radio-input-disabled {
  height: 32px;
  padding: 8px 12px;
  font-weight: 400;
  font-size: 12px;
  color: #00000040;
  line-height: 22px;
  flex-grow: 1;
  background: #00000005;
  border-radius: 4px;
}

.question-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-checkbox-container-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.question-checkbox-container-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-checkbox {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: 12px;
}

.question-checkbox-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.question-input {
  background: #0000000a;
  border-radius: 4px;
  font-size: 12px;
}

.question-success-container {
  position: relative;
  display: flex;
  flex-direction: column;
  top: 129px;
  margin: 0 8px 0 8px;
}

.question-success-img {
}

/deep/ .van-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/deep/ .van-field__value {
  display: flex;
}

/deep/ .van-checkbox__label {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.question-nps-checked {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 32px;
  background: #00796b;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}

.question-nps-unchecked {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 32px;
  background: #0000000a;
  border-radius: 4px;
  font-size: 14px;
  color: #000000a6;
}

.question-nps-group {
  display: flex;
  flex-direction: row;
  gap: 2px;
}

/deep/ .van-radio--horizontal {
  margin-right: 0;
}

/deep/ .van-radio__icon {
  height: auto;
}
/deep/.van-button--disabled {
  opacity: 0.2;
}
</style>
